// extracted by mini-css-extract-plugin
export default {"doctorForm":"docotorForm_doctorForm__kQI2w"};